module.exports = __webpack_public_path__ + "img/service_pattern_02_m.49c36dd8.png";